// app/app.routes.ts
import { Routes } from '@angular/router';
import { DisplayComponent } from './app/pages/display/display';
import { InternalDisplayComponent } from './app/pages/internal-display/internal-display.component';

export const routes: Routes = [
  {
    path: 'pontaj',
    loadChildren: () =>
      import('./app/features/pontaj/pontaj.routes').then(
        (m) => m.PONTAJ_ROUTES,
      ),
  },
  {
    path: 'contract/:token',
    loadComponent: () =>
      import('./app/pages/contract-public/contract-public.component').then(
        (m) => m.ContractPublicComponent,
      ),
    title: 'Semnare Contract — Căsuța Jocului',
  },
  {
    path: 'voluntariat/:token',
    loadComponent: () =>
      import('./app/pages/contract-public/contract-public.component').then(
        (m) => m.ContractPublicComponent,
      ),
    title: 'Semnare Contract Voluntariat — Căsuța Jocului',
  },
  {
    path: 'eveniment/:token',
    loadComponent: () =>
      import('./app/pages/contract-public/contract-public.component').then(
        (m) => m.ContractPublicComponent,
      ),
    title: 'Acord Participare Eveniment — Căsuța Jocului',
  },
  {
    path: 'prezenta-confirmare/:token',
    loadComponent: () =>
      import('./app/pages/prezenta-confirmare/prezenta-confirmare.component').then(
        (m) => m.PrezentaConfirmareComponent,
      ),
    title: 'Confirmare Program — Căsuța Jocului',
  },
  {
    path: 'termeni-contractuali',
    loadComponent: () =>
      import('./app/pages/docs/document-public/document-public.component').then(
        (m) => m.DocumentPublicComponent,
      ),
    data: { docType: 'tcg' },
    title: 'Termeni și Condiții Generale — Căsuța Jocului',
  },
  {
    path: 'regulament-intern',
    loadComponent: () =>
      import('./app/pages/docs/document-public/document-public.component').then(
        (m) => m.DocumentPublicComponent,
      ),
    data: { docType: 'regulament' },
    title: 'Regulament Intern — Căsuța Jocului',
  },
  {
    path: 'platform',
    loadChildren: () =>
      import('./app/platform/platform.routes').then((m) => m.PLATFORM_ROUTES),
  },
  {
    path: 'display',
    component: DisplayComponent,
    title: 'KIDS TERMINAL – READY BOARD',
  },
  {
    path: 'internal-display',
    component: InternalDisplayComponent,
    title: 'INTERNAL TERMINAL',
  },
  {
    path: '',
    loadComponent: () =>
      import('./app/layout/main-layout/main-layout').then(
        (m) => m.MainLayoutComponent,
      ),
    children: [
      // HOME pe rădăcină "/"
      {
        path: '',
        loadComponent: () =>
          import('./app/pages/home/home').then((m) => m.HomeComponent),
        pathMatch: 'full',
        title: 'Acasa',
      },
      {
        path: 'despre-noi',
        loadComponent: () =>
          import('./app/pages/about/about').then((m) => m.About),
        pathMatch: 'full',
        title: 'Despre Noi',
      },

      {
        path: 'noutati',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () =>
              import('./app/pages/updates/updates').then((m) => m.Updates),
            title: 'Noutăți',
          },
          {
            path: ':slug',
            loadComponent: () =>
              import('./app/pages/updates/articles/articles').then(
                (m) => m.Articles,
              ),
            title: 'Articol',
          },
        ],
      },
      {
        path: 'galerie',
        loadComponent: () =>
          import('./app/pages/galerie/galerie').then((m) => m.GaleriePage),
        pathMatch: 'full',
        title: 'Galerie',
      },
      {
        path: 'cariere',
        loadComponent: () =>
          import('./app/pages/cariere/cariere').then((m) => m.CarierePage),
        pathMatch: 'full',
        title: 'Cariere — Căsuța Jocului',
      },
      {
        path: 'oferta',
        loadComponent: () =>
          import('./app/pages/oferta/oferta').then((m) => m.OfertaPage),
        pathMatch: 'full',
        title: 'Ofertă educațională – Căsuța Jocului',
      },
      {
        path: 'inscrieri',
        loadComponent: () =>
          import('./app/pages/inscrieri/inscrieri').then(
            (m) => m.InscrieriPage,
          ),
        pathMatch: 'full',
        title: 'Pre-Inscriere',
      },

      {
        path: 'kidoo',
        loadComponent: () =>
          import('./app/pages/kidoo/kidoo').then((m) => m.KidooPage),
        pathMatch: 'full',
        title: 'Kidoo – Aplicația mobilă Căsuța Jocului',
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./app/pages/contact/contact').then((m) => m.Contact),
        pathMatch: 'full',
        title: 'Contact',
      },

      // alias pentru /home -> /
      { path: 'home', redirectTo: '', pathMatch: 'full' },

      // docs rămâne lazy
      {
        path: 'docs',
        loadChildren: () =>
          import('./app/pages/docs/docs-module').then((m) => m.DocsModule),
      },

      // wildcard -> /
      { path: '**', redirectTo: '' },
    ],
  },
];
